'use client';

import SiteFrequentlyAskedQuestionsComponent from './SiteFrequentlyAskedQuestionsComponent';
import { useTranslation } from '@/hooks/useTranslation';
import CTABanner from '@/components/blocks/CTABanner';

type Props = { locale: string };

const FAQComponent = ({ locale }: Props) => {
  const { t } = useTranslation(locale);
  return (
    <>
      <SiteFrequentlyAskedQuestionsComponent locale={locale} session={'ALL'} />
      <CTABanner
        title={t('Home/ReadyToGetStarted/cta-title')}
        description={t('Home/ReadyToGetStarted/cta-description')}
        cta={t('Home/ReadyToGetStarted/start-trial-aria')}
        ctaTarget="register"
        locale={locale}
      />
    </>
  );
};

export default FAQComponent;
